export default () => +Math.random().toString().slice(2);
